// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"LinkWithTooltip__tooltipContainer___tqRPR","mainContainer":"LinkWithTooltip__mainContainer___BkF9a","skeleton-loading":"LinkWithTooltip__skeleton-loading___cwp9X"};